<template>
  <div class="order-fourth">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">
          <a style="font-weight: normal">
            {{ $t('createQuotation.myQuotation') }}
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>  {{ $t('createQuotation.exportTheShare') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flow-chart">
      <div class="el-steps el-steps--horizontal" style="justify-content: center;">
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump1Step(projectId,projectName)"><i class="el-step__icon-inner step1selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish"> {{ $t('createQuotation.projectBasicInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump2Step(projectId,projectName)">
              <i class="el-step__icon-inner step2selected" />
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.productConfigurationList') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -300ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump3Step(projectId,projectName)"><i class="el-step__icon-inner step3selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.discountInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; max-width: 25%;">
          <div class="el-step__head is-finish">
            <div class="el-step__line"><i class="el-step__line-inner" /></div>
            <div class="el-step__icon is-icon"><i class="el-step__icon-inner step4selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.exportShare') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
      </div>
    </div>
    <div class="share-export">
      <el-row :gutter="200" type="flex" justify="center">
        <el-col :xs="8" :sm="8" :md="8" :lg="7" :xl="6">
          <div class="grid-content bg-purple">
            <div>
              <img src="../../assets/share.png" alt="err">
            </div>
            <div class="btn-pr">
              <el-button type="primary" @click="exportProject">{{ $t('createQuotation.exportQuotation') }}</el-button>
            </div>
          </div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="7" :xl="6">
          <div class="grid-content bg-purple">
            <div>
              <img src="../../assets/export.png" alt="err">
            </div>
            <div class="btn-pr">
              <el-button type="primary" @click="shareProject">{{ $t('createQuotation.shareQuotation') }}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="btn-p">
      <el-button @click="toQuotationList">{{ $t('createQuotation.returnQuotationList') }}</el-button>
      <el-button type="primary" @click="toCreatorderFirst">{{ $t('createQuotation.createNewQuotation') }}</el-button>
    </div>

    <el-dialog
      :title="$t('createQuotation.shareQuotation')"
      :visible.sync="dialogFormVisible"
      style="text-align: left;"
    >
      <div
        style="margin-right: 10px"
      >
        <p
          class="undercarriage"
          v-if="shareMessageDto.lowerShelf !=null && shareMessageDto.lowerShelf !=''"
        >
          {{ $t('homePage.productsPulledQuotation') }}{{ shareMessageDto.lowerShelf }}
        </p>
        <p
          class="undercarriage"
          v-if="shareMessageDto.spdcProduct !=null && shareMessageDto.spdcProduct !=''"
        >
          {{ $t('homePage.serviceProvidersQuotation') }}{{ shareMessageDto.spdcProduct }}
          <span
            v-if="shareMessageDto.orderInfo !=null && shareMessageDto.orderInfo !=''"
          >
            {{ shareMessageDto.orderInfo }}
          </span>
        </p>
        <div style="padding-bottom: 10px">
          <span
            style="text-align: left;color:red;"
            v-if="shareMessageDto.supplyList !==null && shareMessageDto.supplyList.length>0"
          >
            {{ $t('homePage.shortagesProductsQuotation') }}
          </span>
          <span
            style="text-align: left;color:red;"
            v-if="shareMessageDto.deliveryPeriod !=null && shareMessageDto.deliveryPeriod !=''"
          >
            {{ $t('homePage.currentProjectCycle') }}
            {{ shareMessageDto.deliveryPeriod }}
            {{ $t('homePage.DaysCRMSystem') }}
          </span>
        </div>
        <div
          style="text-align: left;color:red"
          v-if="shareMessageDto.promptInformation !=null && shareMessageDto.promptInformation !=''"
        >
          {{ shareMessageDto.promptInformation }}
        </div>
        <div style="text-align: left;color:red" v-if="shareMessageDto.matchingFlg">
          {{ $t('createQuotation.straussClickViewDetails') }}
          <el-button type="primary" @click="openWeakCurrentBoxScene">
            {{ $t('homePage.details') }}
          </el-button>
        </div>
        <div
          class="myBlackColor"
          style="text-align: left;color:red; margin-bottom: 20px"
          v-if="shareMessageDto.supplyList !==null && shareMessageDto.supplyList.length>0"
        >
          <el-table
            :data="shareMessageDto.supplyList"
            border
            style="width: 100%;color: black"
          >
            <el-table-column
              prop="productName"
              :label="$t('homePage.productModel')"
              width="240"
            />
            <el-table-column
              prop="expectedMitigationDate"
              :label="$t('homePage.expectedEaseDate')"
              width="120"
            />
            <el-table-column
              prop="deliveryPeriod"
              :label="$t('homePage.stockCycle')"
              width="100"
            />
            <el-table-column
              prop="supplyRemarks"
              label="$t('homePage.remarks')"
            />
          </el-table>
        </div>
        <div
          class="myBlackColor"
          style="text-align: left;color:red;margin-bottom: 20px"
          v-if="shareMessageDto.delistingProductList !=null && shareMessageDto.delistingProductList.length>0"
        >
          <div style="margin-bottom: 10px">
            {{ $t('createQuotation.quotationDeliStingProducts') }}
          </div>
          <el-table
            :data="shareMessageDto.delistingProductList"
            border
            style="width: 100%;color: black"
          >
            <el-table-column
              prop="productName"
              :label="$t('homePage.productModel')"
              width="240"
            />
            <el-table-column
              prop="statusDes"
              :label="$t('homePage.status')"
            />
          </el-table>
        </div>
      </div>
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth">
          <div class="detail-information">
            <el-row :gutter="20">
              <el-col :span="19">
                <div class="grid-content">
                  <span v-if="form.crm_project_name!==''">
                    {{ $t('homePage.projectName') }}
                  </span>
                  {{ form.crm_project_name }}
                </div>
                <div class="grid-content">
                  <span v-if="form.crm_code!==''">
                    {{ $t('homePage.businessCode') }}
                  </span>
                  {{ form.crm_code }}
                </div>
              </el-col>
              <el-col :span="19">
                <div class="grid-content">
                  <span v-if="form.salesName!==''">
                    {{ $t('homePage.exportSales') }}
                  </span>
                  {{ form.salesName }}
                </div>
                <div class="grid-content">
                  <span v-if="form.preSalesName!==''">
                    {{ $t('homePage.saleTechnicalSupport') }}
                  </span>
                  {{ form.preSalesName }}
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <span class="second-input">
          <el-form-item
            :label="$t('homePage.specifyPeopleShare')"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="userModel"
              multiple
              filterable
              remote
              :reserve-keyword="false"
              :placeholder="$t('homePage.pleaseEnterDesignatedShare')"
              :remote-method="remoteMethodUserBydebounce"
              :loading="loading"
              value-key="userId"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.userId"
                :label="item.userName"
                :value="item"
              >
                <span>
                  <span style="width: 140px;display: inline-block">
                    <!--{{ '[姓名]：' + item.userName }}-->
                    {{ `[${$t('homePage.name')}]：` + item.userName }}
                  </span>
                  <span>
                    [{{ $t('homePage.department') }}]：
                  </span>
                  <span v-if="item.deptName == null">
                    {{ $t('homePage.notHave') }}
                  </span>
                  <span v-if="item.deptName != null">
                    {{ item.deptName }}
                  </span>
                  <span v-if="item.partnerType != null">
                    <!--{{ '  [渠道类型]：' + item.partnerType }}-->
                    {{ `[${$t('homePage.channelType')}]：` + item.partnerType }}
                  </span>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="shareObjectInfo">{{ $t('homePage.share') }}</el-button>
      </div>
    </el-dialog>
    <!--分享前的校验弹窗-->
    <el-dialog
      title="下列产品被分享人没有服务产品权限，将替换为默认服务产品"
      class="search-user-dialog"
      v-loading="loading"
      :visible.sync="isProductRuleDialogVisible"
      :show-close="false"
    >
      <table>
        <tr v-for="(item,j) in productRuleList" :key="j">
          <td class="search-rules-dialog">
            <span
              class="search-rules-dialog-title"
              v-if="isSeries(item)"
              v-html="item"
            />
            <span
              v-else
              style="color: #606266 !important;"
              class="search-rules-dialog-content"
              v-html="item"
            />
          </td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isProductRuleDialogVisible = false;">{{ $t('addConfigModule.cancel') }}</el-button>
        <el-button type="primary" @click="toSecond">{{ $t('exportExcelModule.keepStaring') }}</el-button>
      </div>
    </el-dialog>
    <WeakCurrentBoxScene ref="weakCurrentBoxScene" />
    <!--出口合规风险提示弹窗-->
    <ExportComplianceDialog
      :visible.sync="complianceDialog.visible"
      :mode="complianceDialog.mode"
      :level="complianceDialog.level"
      :conclusion="complianceDialog.conclusion"
      :details="complianceDialog.details"
      @cancel="onComplianceCancel"
      @confirm="onComplianceConfirm"
      @submit-review="onComplianceSubmitReview"
    />
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import api from '../../api';
import step from '../../utils/step';
import { isChannel } from '@/utils/mUtils';
import {  getStore } from '@/utils/mUtils';
import { ProductItem } from '@/utils/numberFormater';
import WeakCurrentBoxScene from '../components/WeakCurrentBoxScene';
import exportCompliance from '@/utils/exportCompliance';
export default {
  components: { WeakCurrentBoxScene },
  mixins: [step, ProductItem, exportCompliance],
  name: 'CreatOrderFourth',
  data () {
    return {
      productRuleList:[], // 分享校验函数数组
      isProductRuleDialogVisible:false, // 分享,校验弹窗
      dialogFormVisible: false,
      list: [],
      options: [],
      crmModel: '',
      userOptions: [],
      userModel: [],
      loading: false,
      projectId: '',
      projectName: '',
      form: {
        crm_code: '',
        crm_project_name: '',
        salesName: '',
        preSalesName: ''
      },
      formLabelWidth: '120px',
      IsChannel: false
    };
  },
  methods: {
    shareProject () {
      this.dialogFormVisible = true;
      this.getLowershelf(this.projectId);
    },
    // 检索CRM项目名称
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        api.getCRMInfoByConditions({ params: { 'keys': query } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.options = json.data;
            if (json.data != null && json.data.length === 1) {
              // this.selectCRM(0);
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$notify.error(json.err);
          }
        }).catch((e) => {
          this.loading = false;
          this.$notify.error('网络异常', e);
        });
      } else {
        this.options = [];
      }
    },
    // 选择CRM时 自动带出客户名称
    selectCRM () {
      this.form.crm_code = this.crmModel.crm_code;
      this.form.crm_project_name = this.crmModel.crm_project_name;
      this.form.salesName = this.crmModel.salesName;
      this.form.preSalesName = this.crmModel.preSalesName;
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    remoteMethodUserBydebounce: XEUtils.debounce(
      function (query) {
        this.remoteMethodUser(query);
      },
      1500
    ),
    // 根据关键字检索用户 > 指定人分享
    remoteMethodUser (query) {
      if (query !== '') {
        this.loading = true;
        api.seachUserByKey({ params: { 'key': query } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.loading = false;
            this.userOptions = json.data;
          } else {
            this.$notify.error(json.data);
          }
        }).catch(() => {
          this.$notify.error(`${this.$('createQuotation.networkAnomaly')}`);
        });
      } else {
        this.userOptions = [];
      }
    },
      //分享指定人
      shareObjectInfo(){
        this.loading=true;
        let submitModel=[];
        let crmUser = [];
        // 分享前,增加的校验接口逻辑
        submitModel=[...this.userModel,...crmUser];
        if (submitModel.length > 0) {
          let  body = {
            projectId:this.projectId,
            commonUserDTOList:submitModel
          };
          api.toShareCheck(body).then(res=>{
            let {data,status,err}=res.data;
            if(status === '200'){
              if(data === null || data.length<=0){
                this.isProductRuleDialogVisible=false;
                this.dialogProductRuleVisible(body);
                this.loading = false;
                return false;
              }
              this.productRuleList = data;
              this.loading = false;
              this.isProductRuleDialogVisible=true;
            }else{
              this.isProductRuleDialogVisible=false;
              this.$notify.error(err);
            }
          }).catch(()=>{
            this.loading = false;
          });
        }else {
          this.$notify.error("请填写指定人！");
        }
      },
      // 分享前,校验提示函数
      dialogProductRuleVisible(params){
        // 分享前先做出口合规检测，通过后再提交分享（携带检测标识供服务端绑定校验）
        this.runExportCompliance(params.projectId, (detectionId) => {
          params.detectionId = detectionId;
          api.toShare(params).then((res) => {
            let json = res.data;
            this.showPrompt(json);
          }).catch(() => {
            this.loading = false;
          });
        });
      },
      // 分享,校验函数,继续跳转
      toSecond(){
        let submitModel=[];
        let crmUser = [];
        submitModel=[...this.userModel,...crmUser];
        let body = {
          projectId: this.projectId,
          commonUserDTOList: submitModel,
        };
        // 分享前先做出口合规检测，通过后再提交分享（携带检测标识供服务端绑定校验）
        this.runExportCompliance(this.projectId, (detectionId) => {
          body.detectionId = detectionId;
          this.loading = true;
          api.toShare(body).then((res) => {
            let json = res.data;
            this.showPrompt(json);
            this.isProductRuleDialogVisible=false;
            this.loading=false;
          }).catch(() => {
            this.loading = false;
          });
        });
      },
    showPrompt (json) {
      if (json.status === '200') {
        this.$notify.success(`${this.$t('homePage.shareSuccess')}`);
      } else if (json.status === '203') {
        let failedUsers = '';
        let reson = '';
        json.data.forEach((userList, index) => {
          failedUsers += index === json.data.length - 1 ? userList.commonUserDTO.userName : userList.commonUserDTO.userName + ',';
          // reson += userList.commonUserDTO.userName + '暂无';
          reson += userList.commonUserDTO.userName + `${this.$t('homePage.notAvailable')}`;
          let products = userList.productInfoLists;
          products.forEach((product, index) => {
            reson += index === userList.productInfoLists.length - 1 ? product.productName + `${this.$t('homePage.permissionsProducts')}` : product.productName + '、';
          });
        });
        reson += `${this.$t('homePage.pleaseModifyShare')}`;
        // let warningContent = '分享【' + failedUsers + '】失败。原因：' + reson;
        let warningContent = `${this.$t('createQuotation.share')}【' + failedUsers + '】${this.$t('createQuotation.shareFailure')}` + reson;
        this.$notify.error(warningContent);
      } else {
        this.$notify.error(json.data);
      }
      this.dialogFormVisible = false;
      this.form.crm_code = '';
      this.form.crm_project_name = '';
      this.form.salesName = '';
      this.form.preSalesName = '';
    },
    toCreatorderFirst () {
      // 与惠平确认，此处按钮为创建一个新的报价单，不是去编辑第一步。
      this.$router.push({ name: 'CreatOrderFirst'/*, query: { secondProjectId:this.projectId} */ });
    },
    toQuotationList () {
      this.$router.push({ name: 'QuotationList'/*, query: {projectId: this.projectId} */ });
    },
    exportProject () {
      this.$router.push({ name: 'exportOrder/export', params: { projectId: this.projectId, projectName: this.projectName } });
    },
    getProjectByProjectId () {
      api.getProjectBaseInfo({ params: { 'projectId': this.projectId } }).then((response) => {
        let jsonData = response.data;
        if (jsonData.status === '200') {
          this.remoteMethod(jsonData.data.crmProjectName);
          this.crmModel = jsonData.data.crmProjectName;
        }
      }, (err) => {
        console.log('分享页面，加载项目基本信息出错===' + err);
      });
    },
    // 获取当前用户信息
    getUserInfo () {
      let temp = getStore(`partnerFlg`);
      if (temp && temp != null && temp != '') {
        this.IsChannel = isChannel(temp);
      } else {
        api.getUserInfo().then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data != null) {
            if (isChannel(json.data.partnerFlg)) {
              this.IsChannel = true;
            } else {
              this.IsChannel = false;
              // 只有内部用户才需要加载crm信息 xingxuegang  2018-11-19 修改
              this.getProjectByProjectId();
            }
          } else {
            this.$notify.error(json.err);
          }
        }).catch((e) => {
          console.log(e);
          this.$notify.error(`${this.$('createQuotation.networkAnomaly')}`);
        });
      }
    },
    openWeakCurrentBoxScene () {
      this.$refs.weakCurrentBoxScene.openWeakCurrentBoxScene();
    }
  },
  mounted () {
    this.projectId = this.$route.query.projectId;
    this.projectName = this.$route.query.projectName;
    if (this.$route.query.dialog) {
      this.dialogFormVisible = true;
    }
    this.getUserInfo();
  }

};
</script>

<style lang="scss">
  .order-fourth .t-r{
    text-align: right;
  }
  .order-fourth {
    padding-top: 10px;
  .el-step__icon.is-icon{
    width: 6rem !important;
  }
  }
  .order-fourth .flow-chart{
    max-width:1200px;
    min-width: 1024px;
    margin: 2rem auto 0;
  }

  .el-breadcrumb__item .el-breadcrumb__inner{
    font-weight: normal;
    color:#36BAE2;
  }

  .el-breadcrumb__item:hover .el-breadcrumb__inner{
    color:#36BAE2;
  }

  .el-step__title.is-process {
    font-weight: normal;
  }

  .order-fourth .flow-chart img{
    width: 80%;
    text-align: center;
  }
  .order-fourth .order-form{
    margin-top: 9rem;
  }

  .el-breadcrumb__item .el-breadcrumb__inner{
    font-weight: normal;
    color:#36BAE2;
  }

  .el-breadcrumb__item:hover .el-breadcrumb__inner{
    color:#36BAE2;
  }

  .order-fourth .demo-input-suffix{
    margin-top: 2rem;
  }

  .order-fourth .demo-input-suffix input{
    height: 3.4rem;
  }

  .order-fourth .demo-input-suffix .grid-content{
    line-height: 3.4rem;
  }

  .order-fourth  textarea:focus {
    border-color: #36BAE2!important;
  }

  .order-fourth .el-button--primary {
    color: #fff;
    background-color: #36BAE2!important;
    border-color: #36BAE2!important;
  }

  .order-fourth .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8!important;
    border-color: #60c8e8!important;
  }

  .order-fourth .el-button--default:hover{
    border:#36BAE2!important;
    color:#36BAE2!important;
    border:1px solid #36BAE2!important;
    background: rgba(54,186,222,0.2);
  }
  .order-fourth .share-export{
    margin-top: 4rem;
  }

  .order-fourth .share-export img{
    width:48px;
    height:48px;
  }

  .order-fourth .share-export .grid-content{
    border: 1px solid #EBEBEB;
    padding-top: 6rem;
    padding-bottom: 4rem;
  }

  .order-fourth .share-export .btn-pr{
    margin-top: 6rem;
  }

  .order-fourth .share-export .el-button--primary{
    width: 80%;
    height: 32px;
    background-color: #fff !important;
    color: #3fbbdc !important;
    border: 1px solid #3fbbdc !important;
    line-height: 0px;
  }

  .order-fourth .share-export .el-col-lg-7{
    width: 34%;
  }
  .order-fourth .btn-p .el-button--default{
    width: 20rem;
    height: 3.2rem;
    line-height: 0;
  }

  .order-fourth .btn-p .el-button--primary{
    width: 20rem;
    margin-left: 4rem;
    height: 3.2rem;
    line-height: 0;
  }

  .order-fourth .el-button--primary{
    margin-left: 0;
  }

  .order-fourth .el-dialog .el-dialog__header{
    text-align: left;
    font-size: 1.6rem;
    border-bottom: 1px solid #EBEBEB;
    padding: 16px 20px 10px;
  }

  .order-fourth .el-form{
    width: 100%;
    margin: 0 auto;
  }

  .order-fourth .el-form-item__content{
    width: 50rem;
  }

  .order-fourth .el-form-item__content .el-select{
    width: 80%;
  }

  .order-fourth .detail-information{
    text-align: left;
    margin-bottom: 1.8rem;
  }

  .order-fourth .detail-information span{
    color: #333333;
  }
  .order-fourth .el-form-item{
    margin-bottom: 0;
  }
  .order-fourth .detail-information .el-row{
    margin-bottom: 1rem;
  }

  .order-fourth {
    .dialog-footer{
      text-align: right;
      margin-top: 50px;
    }
    .dialog-footer button:first-child{
      margin-right: 10px;
    }
  }

  .second-input input:focus{
    border: none!important;
  }

  .detail-information .second-input .el-input--suffix input:hover{
    border: none!important;
  }
  .detail-information .second-input .el-input--suffix input:focus{
    border: none!important;
  }

  .order-fourth .detail-information .grid-content{
    float: left;
    width: 50%;
    margin-top: 1rem;
  }

  .order-fourth .share-export{
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    min-width: 1024px;
  }

  .order-fourth .second-input .el-select__input:focus{
    border: none!important;
  }

  .order-fourth .second-input .el-select__input:hover{
    border: none!important;
  }

  .order-fourth .btn-p{
    margin-top: 4rem;
  }

  .order-fourth .el-tag{
    display: inline-block;
    height: 2.4rem;
    line-height: 2.4rem;
  }

  .crumbs-navigation .el-breadcrumb__inner a{
    color: #36bade!important;
  }

  .order-fourth .el-dialog__body{
    //padding: 0 0 0 60px;
  }
  .undercarriage{
    padding: 10px 10px;
    color: #dd0000;
    font-size: 14px;
    border: 1px solid red;
    text-align: left;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 1334px) {
    .order-fourth{
      width: 1294px;
    }

    .order-fourth .flow-chart img{
      width: 60%;
    }

    .order-fourth .share-export img{
      width:15%;
    }

    .order-fourth .share-export .el-button--primary{
      width: 70%;
      height: 3rem;
      line-height: 0px;
    }

    .order-fourth .btn-p .el-button--default{
      width: 16rem;
      height: 3rem;
      line-height: 0;
    }

    .order-fourth .btn-p .el-button--primary{
      width: 16rem;
      margin-left: 4rem;
      height: 3rem;
      line-height: 0;
    }

    .order-fourth .share-export{
      margin-top: 5rem;
    }

    .order-fourth .share-export .grid-content {
      border: 1px solid #EBEBEB;
      padding-top: 4rem;
      padding-bottom: 3rem;
    }

    .order-fourth .btn-p{
      margin-top: 5rem;
    }

    .order-fourth .share-export .btn-pr {
      margin-top: 5rem;
    }

  }

  @media screen and (max-width: 1366px){
    .order-fourth{
      width: 100%;
    }

    .order-fourth .share-export{
      margin-top: 5rem;
    }

    .order-fourth .share-export .el-col-lg-7 {
      width:30%;
    }

    .order-fourth .btn-p {
      margin-top: 4rem;
    }
    .order-fourth .share-export .el-button--primary {
      width: 80%;
      height: 3rem;
      line-height: 0px;
      font-size: 1.2rem;
    }
    .order-fourth .share-export .grid-content{
      padding-top: 4rem;
      padding-bottom: 2rem;
    }
    .order-fourth .share-export .btn-pr {
      margin-top: 3rem;
    }
  }

  @media screen and (max-width: 1280px) {
  }
</style>
